import { NgModule } from '@angular/core';
import { DashboardSharedModule } from 'src/app/dashboards/dashboard-shared/dashboard-shared.module';
import { PilotKpiStatsViewBuilderComponent } from 'src/app/dashboards/pilot-dashboard/pilot-kpis/components/pilot-kpi-stats/pilot-kpi-stats-view-builder.component';
import { PilotKpiStatsViewComponent } from 'src/app/dashboards/pilot-dashboard/pilot-kpis/components/pilot-kpi-stats/pilot-kpi-stats-view.component';

@NgModule({
  imports: [DashboardSharedModule],
  declarations: [PilotKpiStatsViewComponent, PilotKpiStatsViewBuilderComponent],
  exports: [PilotKpiStatsViewBuilderComponent],
  entryComponents: [PilotKpiStatsViewComponent],
})
export class PilotKpisModule {}
